import { AppNames } from "@watt/common/libs/supabase/cookie-config";
import { createBrowserClientForAppName } from "@watt/db/supabase/client";

export const createBrowserClient = () =>
  createBrowserClientForAppName(AppNames.CRM);
